import PropTypes from "prop-types";
import { Label } from "@/components/ui/label";
import { NativeSelect } from "@/components/ui/native-select";

/**
 * Project scope picker — the source of truth is the URL's `?project=` query
 * param. `scope` and `onChange` are passed in by TaskBoard, which reads and
 * writes the URL via useSearchParams. This keeps the picker stateless and
 * makes deep-linking work for free.
 */
function ProjectPicker({ scope, projects, onChange }) {
  return (
    <div>
      <Label htmlFor="project-picker" className="sr-only">
        Project
      </Label>
      <NativeSelect
        id="project-picker"
        aria-label="Project"
        className="max-w-60"
        value={scope}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="all">All projects</option>
        <option value="none">No project</option>
        {projects.map((project) => (
          <option key={project.id} value={String(project.id)}>
            {project.name}
          </option>
        ))}
      </NativeSelect>
    </div>
  );
}

ProjectPicker.propTypes = {
  scope: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProjectPicker;
